export default __webpack_public_path__ + "static/media/Delete.ad3364c9.svg";